import {
  IonCheckbox,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonRadioGroup,
} from "@ionic/react";
import { checkmarkCircle } from "ionicons/icons";
import store from "../../../store";

export default () => {
  const { currentQualityDocument } = store.getState();
  const isVersion5 = currentQualityDocument.version >= 5;
  const isVersion6 = currentQualityDocument.version >= 6;
  const pictureList = Array.isArray(currentQualityDocument.picture)
    ? currentQualityDocument.picture
    : [];

  const pictures =
    pictureList.length > 0 ? (
      <>
        <p>Uppladdade bilder</p>
        <div className="form-group form-group-simple form-group-images d-flex">
          {pictureList.map((picture: any, index: number) => (
            <div className="image-col" key={index}>
              <IonItem lines="none" color="white">
                <img
                  src={`data:image/${picture.extension};base64,${picture.data}`}
                  alt=""
                />
              </IonItem>
            </div>
          ))}
        </div>
      </>
    ) : (
      ""
    );

  const notes =
    currentQualityDocument.otherinformation !== "" ? (
      <>
        <p>
          Övriga upplysningar/eventuella avvikelser från Byggkeramikrådets
          Branschregler för Våtrum (BBV){" "}
        </p>
        <div className="form-group">
          <IonItem lines="none" color="white" className="ion-no-padding">
            <div className="form-value">
              {currentQualityDocument.otherinformation}
            </div>
            <IonIcon
              icon={checkmarkCircle}
              className="form-group-icon"
              color="success"
              size="small"
            />
          </IonItem>
        </div>
      </>
    ) : (
      ""
    );

  const discrepancies =
    isVersion5 && currentQualityDocument.discrepancies !== "" ? (
      <>
        <p>Avtalade avvikelser</p>
        <div className="form-group">
          <IonItem lines="none" color="white" className="ion-no-padding">
            <div className="form-value">
              {currentQualityDocument.discrepancies}
            </div>
            <IonIcon
              icon={checkmarkCircle}
              className="form-group-icon"
              color="success"
              size="small"
            />
          </IonItem>
        </div>
      </>
    ) : (
      ""
    );

  const controlText =
    currentQualityDocument.version <= 3
      ? "Egenkontrollen innefattar följande kontrollpunkter med hänvisning till kapitel 6:533 i Boverkets byggregler, BFS 2011:6 med ändringar t.o.m. BFS 2015:3, BBR"
      : "Egenkontrollen innefattar följande kontrollpunkter med hänvisning till kapitel 6:533 i Boverkets byggregler, BFS 2011:6 med ändringar t.o.m. BFS 2020:4, BBR";

  // Helper function to get foundation display value
  const getFoundationDisplayValue = (foundation: any) => {
    if (isVersion5) {
      // Version 5 uses string values: "yes", "no", "no_bbv"
      if (foundation === "empty") return "Nej";
      if (foundation === "no") return "Nej";
      if (foundation === "yes") return "Ja";
      if (foundation === "no_bbv") return "BBV Ej tillämpbart";
      return "BBV Ej tillämpbart";
    } else {
      // Version <= 4 uses boolean values
      if (foundation === "empty") return "Nej";
      if (foundation === "no" || foundation === false) return "Nej";
      if (foundation === "yes" || foundation === true) return "Ja";
      return "BBV Ej tillämpbart";
    }
  };

  return (
    <IonItemGroup className="form-section form-section-readonly">
      <IonItemDivider sticky={true} mode="ios">
        Egenkontroll
      </IonItemDivider>
      <h2 className="ion-margin-bottom">{controlText}</h2>
      {isVersion5 && (
        <IonItemDivider sticky={true} mode="ios">
          Underlag
        </IonItemDivider>
      )}

      <p>Underlagen uppfyller branschreglernas krav (Golv)</p>
      <div className="form-group-multiple">
        <IonRadioGroup>
          <IonItem lines="none" color="white">
            <div className="form-value">
              {getFoundationDisplayValue(
                isVersion5
                  ? currentQualityDocument.floorfoundation
                  : currentQualityDocument.floorfoundationok,
              )}
            </div>
            <IonIcon
              icon={checkmarkCircle}
              className="form-group-icon"
              color="success"
              size="small"
            />
          </IonItem>
        </IonRadioGroup>
      </div>
      {isVersion5 && (
        <p className="form-description font-size-xs">
          Om <strong>"Nej"</strong> eller <strong>"BBV Ej tillämpbart"</strong>{" "}
          förtydliga nedan under punkten <strong>övriga upplysningar</strong>.
        </p>
      )}
      <p>Underlagen uppfyller branschreglernas krav (Vägg)</p>
      <div className="form-group-multiple">
        <IonRadioGroup>
          <IonItem lines="none" color="white">
            <div className="form-value">
              {getFoundationDisplayValue(
                isVersion5
                  ? currentQualityDocument.wallfoundation
                  : currentQualityDocument.wallfoundationok,
              )}
            </div>
            <IonIcon
              icon={checkmarkCircle}
              className="form-group-icon"
              color="success"
              size="small"
            />
          </IonItem>
        </IonRadioGroup>
      </div>
      {isVersion5 && (
        <p className="form-description font-size-xs">
          Om <strong>"Nej"</strong> eller <strong>"BBV Ej tillämpbart"</strong>{" "}
          förtydliga nedan under punkten <strong>övriga upplysningar</strong>.
        </p>
      )}
      {isVersion5 && (
        <>
          <p>
            Lutning på golv i plats för bad och dusch mot golvavlopp uppfyller
            branschreglernas krav (1:50–1:150/1:100–1:200) innan tätskikt
            applicerats.
          </p>
          <div className="form-group-multiple">
            <IonRadioGroup>
              <IonItem lines="none" color="white">
                <div className="form-value">
                  {currentQualityDocument.floorslope === true ? "Ja" : "Nej"}
                </div>
                <IonIcon
                  icon={checkmarkCircle}
                  className="form-group-icon"
                  color="success"
                  size="small"
                />
              </IonItem>
            </IonRadioGroup>
          </div>
          <p className="form-description font-size-xs">
            Om <strong>"Nej"</strong> förtydliga nedan under punkten{" "}
            <strong>övriga upplysningar</strong>.
          </p>

          <p>Har annan lutning avtalats på övrig golvyta än det BBV anger?</p>
          <div className="form-group-multiple">
            <IonRadioGroup>
              <IonItem lines="none" color="white">
                <div className="form-value">
                  {currentQualityDocument.floorslopenotok === true
                    ? "Ja"
                    : "Nej"}
                </div>
                <IonIcon
                  icon={checkmarkCircle}
                  className="form-group-icon"
                  color="success"
                  size="small"
                />
              </IonItem>
            </IonRadioGroup>
          </div>
          <p className="form-description font-size-xs">
            Om <strong>"Ja"</strong> förtydliga nedan under punkten{" "}
            <strong>avtalade avvikelser</strong>.
          </p>
        </>
      )}
      {isVersion5 && (
        <IonItemDivider sticky={true} mode="ios">
          Tätskikt
        </IonItemDivider>
      )}
      <div className="form-group form-group-simple form-group-cb">
        <IonItem lines="none" className="ion-no-padding">
          <IonCheckbox
            name="sealingworkok"
            disabled
            checked={currentQualityDocument.sealingworkok}
          />
          <IonLabel>
            Tätskiktsarbetet är utfört enligt aktuell monteringsanvisning
          </IonLabel>
        </IonItem>
      </div>
      {isVersion5 && (
        <div className="form-group form-group-simple form-group-cb">
          <IonItem lines="none" className="ion-no-padding">
            <IonCheckbox
              name="tresholdok"
              disabled
              checked={currentQualityDocument.tresholdok}
            />
            <IonLabel>Uppvik mot tröskel är korrekt utfört</IonLabel>
          </IonItem>

          <IonItem lines="none" className="ion-no-padding">
            <IonCheckbox
              name="sealingdoorwindow"
              disabled
              checked={currentQualityDocument.sealingdoorwindow}
            />
            <IonLabel>
              Tätskikt är korrekt applicerat vid dörr eller fönster
            </IonLabel>
          </IonItem>

          <IonItem lines="none" className="ion-no-padding">
            <IonCheckbox
              name="pipesealingok"
              disabled
              checked={currentQualityDocument.pipesealingok}
            />
            <IonLabel>
              Samtliga genomföringar är förseglade enligt anvisning
            </IonLabel>
          </IonItem>
        </div>
      )}
      <p>Finns andra genomföringar i golvets tätskikt än avlopp?</p>
      <div className="form-group-multiple">
        <IonRadioGroup>
          <IonItem lines="none" color="white">
            <div className="form-value">
              {currentQualityDocument.otherleadthrough === false ? "Nej" : "Ja"}
            </div>
            <IonIcon
              icon={checkmarkCircle}
              className="form-group-icon"
              color="success"
              size="small"
            />
          </IonItem>
        </IonRadioGroup>
      </div>
      {isVersion5 && (
        <p className="form-description font-size-xs">
          Om <strong>"Ja"</strong> förtydliga nedan under punkten{" "}
          <strong>avtalade avvikelser</strong>.
        </p>
      )}
      {discrepancies}
      {notes}
      {isVersion5 && (
        <IonItemDivider sticky={true} mode="ios">
          Golvbrunn
        </IonItemDivider>
      )}
      <div className="form-group form-group-simple form-group-cb">
        {!isVersion5 && (
          <IonItem lines="none" className="ion-no-padding">
            <IonCheckbox
              name="floorslope"
              disabled
              checked={currentQualityDocument.floorslope}
            />
            <IonLabel>
              Lutning på golv mot golvavlopp uppfyller branschreglernas krav
              (1:50–1:150/1:100–1:200) innan tätskikt applicerats.
            </IonLabel>
          </IonItem>
        )}

        {isVersion5 && isVersion6 ? (
          <>
            <IonItem lines="none" className="ion-no-padding">
              <IonCheckbox
                name="newfloordrain"
                disabled
                checked={currentQualityDocument.newfloordrain === true}
              />
              <IonLabel>Ny typgodkänd golvbrunn har installerats</IonLabel>
            </IonItem>
            <IonItem lines="none" className="ion-no-padding">
              <IonCheckbox
                name="welltypeapproved"
                disabled
                checked={currentQualityDocument.welltypeapproved}
              />
              <IonLabel>Befintlig typgodkänd golvbrunn är intakt</IonLabel>
            </IonItem>
          </>
        ) : (
          <IonItem lines="none" className="ion-no-padding">
            <IonCheckbox
              name="welltypeapproved"
              disabled
              checked={currentQualityDocument.welltypeapproved}
            />
            <IonLabel>
              Har ny typgodkänd golvbrunn installerats eller är befintlig
              golvbrunn typgodkänd och intakt?
            </IonLabel>
          </IonItem>
        )}

        <IonItem lines="none" className="ion-no-padding">
          <IonCheckbox
            name="wellbyothercontractor"
            disabled
            checked={currentQualityDocument.wellbyothercontractor}
          />
          <IonLabel>Ny golvbrunn monterad av annan entreprenör</IonLabel>
        </IonItem>

        <IonItem lines="none" className="ion-no-padding">
          <IonCheckbox
            name="wellfixedmount"
            disabled
            checked={currentQualityDocument.wellfixedmount}
          />
          <IonLabel>
            Golvbrunnen är fast monterad och i nivå med tätskiktet.
          </IonLabel>
        </IonItem>

        {isVersion5 && (
          <>
            <p>Golvbrunnstyp</p>
            <div className="form-group-multiple">
              <IonRadioGroup>
                <IonItem lines="none" color="white">
                  <div className="form-value">
                    {currentQualityDocument.draintype === "close_to_wall"
                      ? "Väggnära golvbrunn"
                      : currentQualityDocument.draintype === "round"
                        ? "Rund golvbrunn"
                        : "-"}
                  </div>
                  <IonIcon
                    icon={checkmarkCircle}
                    className="form-group-icon"
                    color="success"
                    size="small"
                  />
                </IonItem>
              </IonRadioGroup>
            </div>

            <p>Anslutning</p>
            <div className="form-group-multiple">
              <IonRadioGroup>
                <IonItem lines="none" color="white">
                  <div className="form-value">
                    {currentQualityDocument.clamptype === "twist"
                      ? "Skruvbar klämring"
                      : currentQualityDocument.clamptype === "glue"
                        ? "Limfläns"
                        : currentQualityDocument.clamptype === "mecanic"
                          ? "Mekanisk klämring"
                          : "-"}
                  </div>
                  <IonIcon
                    icon={checkmarkCircle}
                    className="form-group-icon"
                    color="success"
                    size="small"
                  />
                </IonItem>
              </IonRadioGroup>
            </div>
          </>
        )}
      </div>
      {pictures}
    </IonItemGroup>
  );
};
